import Chip from 'components/Chip'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useEffect, useState, useRef } from 'react'
import AppsList from '../AppsList'
import { navigate } from 'gatsby'
import { prepareData } from 'utils/googleData'

const filters = [
    {
        type: 'type',
        name: 'Collections',
    },
    {
        type: 'type',
        name: 'Productivity',
    },
    {
        type: 'type',
        name: 'Resident-Services',
    },
    {
        type: 'type',
        name: 'PM-Services',
    },
    {
        type: 'type',
        name: 'Associations',
    },
    {
        type: 'type',
        name: 'Other',
    },
    // {
    //     type: 'maintainer',
    //     name: 'Official',
    // },
    // {
    //     type: 'maintainer',
    //     name: 'Support',
    // },
]

export function Apps(props) {
    const prevSearchParamsRef = useRef()
    const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, plans, searchParams } =
        prepareData({
            props,
        })
    // console.log('plans', JSON.stringify(plans))
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const {
        apps: { nodes },
    } = useStaticQuery(query)
    const [apps, setApps] = useState(nodes)
    const [filteredApps, setFilteredApps] = useState(nodes)
    const [currentFilter, setCurrentFilter] = useState('all')
    // const filter = (filter) => apps?.filter(filter)

    const filterApps = (type, name) => {
        let filteredApps = []
        if (type === 'type') {
            filteredApps = apps.filter((app) => app?.frontmatter?.pluginType?.includes(name))
        }
        if (type === 'maintainer') {
            filteredApps = apps.filter((app) => app?.frontmatter?.maintainer === name)
        }
        if (type === 'builtIn') {
            filteredApps = apps.filter((app) => app?.frontmatter?.builtIn)
        }
        setCurrentFilter(name)
        setFilteredApps(filteredApps)
    }

    const resetFilters = () => {
        navigate('?')
        setCurrentFilter('all')
        setFilteredApps(apps)
    }

    useEffect(() => {
        if (
            prevSearchParamsRef.current?.filter !== searchParams.filter ||
            prevSearchParamsRef.current?.value !== searchParams.value
        ) {
            filterApps(searchParams.filter, searchParams.value)
            prevSearchParamsRef.current = searchParams
        }
    }, [searchParams])

    return (
        <>
            <header className="py-12">
                <h2 className="m-0 text-center text-[2.75rem] leading-none  text-primary md:text-4xl">
                    Level up your integrations with
                    <br className="hidden lg:block " />
                    <span className="text-red  md:text-6xl">iCloudReady Marketplace</span>
                </h2>
                <p className="my-6 mx-auto mt-2 max-w-2xl text-center text-lg font-semibold text-primary opacity-75 dark:text-white md:text-lg lg:mt-4">
                    iCloudReady Marketplace gives you the power to customize your key workflows to match how your
                    business operates, all within our easy-to-use platform. Our partners are top proptech solutions on
                    the market that give your business a competitive edge while enhancing productivity and improving the
                    resident experience.
                </p>
            </header>
            <div className="mb-6 flex items-center justify-start space-x-2 overflow-auto whitespace-nowrap px-4 md:justify-center">
                <Chip onClick={resetFilters} active={currentFilter === 'all'} text="All" />
                {filters?.map(({ type, name }) => (
                    <Chip
                        onClick={() => navigate(`?filter=${type}&value=${name.toLowerCase()}`)}
                        active={currentFilter === name.toLowerCase()}
                        key={name}
                        text={name}
                    />
                ))}
            </div>
            <AppsList apps={filteredApps} />
        </>
    )
}

const query = graphql`
    query {
        apps: allMdx(filter: { fields: { slug: { regex: "/^/marketplace/(?!.*/docs).*/" } } }) {
            nodes {
                id
                fields {
                    slug
                }
                frontmatter {
                    thumbnail {
                        childImageSharp {
                            gatsbyImageData(placeholder: NONE)
                        }
                    }
                    title
                    badge
                    price
                    pluginType
                    maintainer
                }
                parent {
                    ... on GoogleDocs {
                        images {
                            name
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                        images2: images {
                            name
                            publicURL
                            childImageSharp {
                                gatsbyImageData(width: 256, height: 256)
                            }
                        }
                        footer {
                            image {
                                publicURL
                                childImageSharp {
                                    gatsbyImageData(placeholder: NONE)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export default Apps
